/** @jsx jsx */
import { useContext } from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import { Text, Box, jsx } from "theme-ui"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import BlockContent from "@sanity/block-content-to-react"

import { Context } from "../../context/MainContext"

import { underline } from "../../mixins"
import enums from "../../util/enums"

import Melt from "../../images/melt.mp4"

const Intro = () => {
  const styles = {
    container: {
      position: "relative",
      color: "darkGreen",
      fontFamily: "body",
      display: "grid",
      gridTemplateColumns: ["1fr", "1fr", "1fr", "1fr 1fr"],
      gridTemplateRows: "auto",
    },
    video: {
      objectFit: "cover",
      width: ["100%", null, "calc(100% + 2px)"],
      maxWidth: "100%",
      height: ["auto", "auto", "auto", "800px"],
      gridRow: ["2", "2", "2", "1"],
    },
    nav: {
      display: "flex",
      flex: 1,
      alignItems: "flex-end",
      marginTop: "1em",
      marginBottom: "0.1em",
      fontSize: ["32px", "38px", "50px", "42px", "50px"],
      span: {
        padding: "0 0.25em",
      },
    },
    text: {
      display: "flex",
      flexDirection: "column",
      "h2, p": {
        fontWeight: "normal",
        fontSize: ["32px", "38px", "50px", "42px", "50px"],
        "&:first-child": {
          marginTop: "0px",
        },
        "&:nth-child(2)": {
          marginTop: "1em",
        },
      },
      position: "relative",
      padding: [
        "16px 8px 48px",
        "16px 8px 48px",
        "16px 8px 48px",
        "20px 20px 0",
      ],
      gridRow: "1",
    },
  }

  const { sanityIntroduction } = useStaticQuery(graphql`
    query IntroQuery {
      sanityIntroduction(_id: { eq: "introduction" }) {
        content: _rawContent
        linkText1
        linkText2
      }
    }
  `)

  const { linkText1, linkText2, content } = sanityIntroduction

  const BlockRenderer = props => {
    if (props.node.style === "normal") {
      return (
        <Text as="p" sx={styles.smallText}>
          {props.children}
        </Text>
      )
    }
    return BlockContent.defaultSerializers.types.block(props)
  }

  const { setCaseBuilderMode } = useContext(Context)

  return (
    <Box as="section" backgroundColor={"lightGreen"} sx={styles.container}>
      <video sx={styles.video} autoPlay loop muted playsInline>
        <source src={Melt} type="video/mp4" />
      </video>
      <Box sx={styles.text}>
        <BlockContent
          blocks={content}
          serializers={{ types: { block: BlockRenderer } }}
        />
        <Text as="nav" variant="body" sx={styles.nav}>
          <Link
            to="/find-us"
            sx={{
              ...underline("#004C26"),
              ":hover": {
                opacity: 0.65,
              },
            }}
          >
            {linkText1}
          </Link>
          <span>{"/"}</span>
          <AnchorLink
            to="/#our-pints"
            sx={{
              ...underline("#004C26"),
              ":hover": {
                opacity: 0.65,
              },
            }}
          >
            <span
              onClick={() => {
                setCaseBuilderMode(enums.mode.bundle)
              }}
            >
              {linkText2}
            </span>
          </AnchorLink>
        </Text>
      </Box>
    </Box>
  )
}

export default Intro
